/* ------------------------------------------ GRYFF COLLECTION SELECTOR - CHRIS 18.08.2016 ----------------------------------------- */
import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import api from '@/app/endpoints.js';
import { GET } from '@/app/api/index';

(function (jQuery) {
  jQuery.gfLinkPicker = function (element, options) {
    const defaults = {
      option: null,
      notarget: false,
      detectChange: function () {},
      onOpacity: function () {},
      offOpacity: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;
    let _dataPages = [];
    let _dataProducts = [];
    let _dataCollections = [];
    let _dataArticles = [];
    let _dataTarget;
    let _cSelector = '<a id="gf-pick-link" class="button" href="#">' + utils.svgIcon('link-picker') + ' Pick Link</a>';
    const _mdLinkPicker = '<div id="md-link-picker"></div>';
    let _content;

    let $activeModal;
    let delaySearch;
    let _tabInit;
    let _countCheckActive = 0;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      _content =
        '<div class="gfLP_header"> <div class="gfLP_header-url"> <div class="gfLP_header-left"' +
        (_this.settings.notarget ? '' : ' style="margin-right: 20px;"') +
        '> <p>Custom URL</p> <input id="gfLP_link" placeholder="https://gempages.net" /> <div class="gfLP_boder"></div> <svg class="gfLP_icon_link"></svg> <div class="gfLP_icon_clear_body"> <svg class="gfLP_icon_clear"></svg> </div> </div> <div class="gfLP_header-right"' +
        (_this.settings.notarget ? ' style="display: none;"' : '') +
        '> <p>Target</p> <span id="gfLP_target" data-value="_blank">New tab</span> <ul> <li data-value="" >Current Tab</li> <li data-value="_blank">New Tab</li> </ul> <svg class="gfLP_icon_target"></svg> </div> </div> <div class="gfLP_tabs"> <ul> <li data-tab="Pages"> <a>Pages</a> </li> <li data-tab="Collections"> <a>Collections</a> </li> <li data-tab="Products"> <a>Products</a> </li> <li data-tab="Articles"> <a>Articles</a> </li> <li data-tab="Scroll To"> <a>Scroll To</a> </li> <li data-tab="Email"> <a>Email</a> </li> <li data-tab="Phone"> <a>Phone</a> </li> </ul> </div> </div> <div class="gfLP_body"> <div class="gfLP_search-link"> <input type="text" placeholder="search ..."/> <svg class="gfLP_icon_search"><svg> </div> <div class="gfLP_content" data-tab="Pages"> <div class="page-list"></div> </div> <div class="gfLP_content" data-tab="Products"> <div class="product-list"></div> </div> <div class="gfLP_content" data-tab="Collections"> <div class="collection-list"></div> </div> <div class="gfLP_content" data-tab="Scroll To"> <div class="section-list"></div> </div> <div class="gfLP_content" data-tab="Articles"> <div class="articles-list"></div> </div> <div class="gfLP_content" data-tab="Email"> <div class="email-list"> <label>Email Address</label> <input type="email" name="email" placeholder="chris@gempages.help" /> <label>Subject</label> <input type="text" name="subject" placeholder="Need support!" /> <label>Message</label> <textarea type="text" name="message" placeholder="Hi, I\'m [your-name]\nI currently have a problem:\nLooking forward to your answer.\nRegards"></textarea> </div> </div> <div class="gfLP_content" data-tab="Phone"> <div class="phone-list"> <label>Phone Number</label> <input type="text" name="phone" placeholder="+1-708-943-8364" /> </div> </div> </div>';

      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      const $targetElement = $gryffBody.find('#' + merId);

      if ($targetElement.attr('data-label') == 'Button') {
        _cSelector +=
          '<a id="gf-pick-action" class="button" href="#">' + utils.svgIcon('touch-finger') + ' Pick Action</a>';
      }
      if ($element.next('#gf-pick-link').length == 0) {
        $element.after(_cSelector);
      }
      this.setTemplate();

      return false;
    };

    this.setTemplate = function () {
      const $dad = $element.closest('.gfSettingGroup');

      const $pickLink = $element.next('#gf-pick-link');
      const $pickAction = $dad.find('#gf-pick-action');
      $pickLink.off('click').on('click', function () {
        $divContentHidden.append(_mdLinkPicker);
        $activeModal = $divContentHidden.find('#md-link-picker');
        $activeModal.gfModalNew({
          title: 'Link picker',
          header: 'noIcon',
          footer: 'footer',
          background: '#F3F5F9',
          width: 580,
          height: 650,
          left: $gfLeftSideBar.children().innerWidth(),
          top: $divTopBar.innerHeight(),
          loading: true,
          onContent: function ($content) {
            $content.html(_content);
            const valueInit = $element.val();
            $content.find('#gfLP_link').val(valueInit);

            if (_this.settings.option && _this.settings.option == 'link') {
              $activeModal.find('.gfLP_tabs li[data-tab="Email"]').hide();
              $activeModal.find('.gfLP_tabs li[data-tab="Phone"]').hide();
              $activeModal.find('.gfLP_tabs li[data-tab="Scroll To"]').hide();
            }

            let _target = $gfLeftSideBar.find('.linkTarget,#linkTarget,#url-target,#icon-target').val();

            // Text editor target setting
            if (_target == undefined) {
              _target = $element.attr('data-target');
            }

            if (_target) {
              if (_target == '_blank') {
                $content.find('#gfLP_target').attr('data-value', _target).text('New Tab');
              } else {
                $content.find('#gfLP_target').attr('data-value', '').text('Current Tab');
              }
              _dataTarget = _target;
            } else {
              $content.find('#gfLP_target').attr('data-value', '').text('Current Tab');
              _dataTarget = '';
            }

            if (valueInit.indexOf('/pages/') >= 0) {
              _tabInit = 'Pages';
              $activeModal.find('.gfLP_tabs li[data-tab="Pages"]').addClass('active');
              $activeModal.find('.gfLP_content[data-tab="Pages"]').addClass('active');
              _this.ajaxRequest('Pages');
            } else if (valueInit.indexOf('/collections/') >= 0) {
              _tabInit = 'Collections';
              $activeModal.find('.gfLP_tabs li[data-tab="Collections"]').addClass('active');
              $activeModal.find('.gfLP_content[data-tab="Collections"]').addClass('active');
              _this.ajaxRequest('Collections');
            } else if (valueInit.indexOf('/products/') >= 0) {
              _tabInit = 'Products';
              $activeModal.find('.gfLP_tabs li[data-tab="Products"]').addClass('active');
              $activeModal.find('.gfLP_content[data-tab="Products"]').addClass('active');
              _this.ajaxRequest('Products');
            } else if (valueInit.indexOf('/articles/') >= 0) {
              _tabInit = 'Articles';
              $activeModal.find('.gfLP_tabs li[data-tab="Articles"]').addClass('active');
              $activeModal.find('.gfLP_content[data-tab="Articles"]').addClass('active');
              _this.ajaxRequest('Articles');
            } else {
              if (_this.settings.option && _this.settings.option == 'link') {
                _tabInit = 'Pages';
                $activeModal.find('.gfLP_tabs li[data-tab="Pages"]').addClass('active');
                $activeModal.find('.gfLP_content[data-tab="Pages"]').addClass('active');
                _this.ajaxRequest('Pages');
              } else {
                if (valueInit.indexOf('mailto:') >= 0) {
                  _tabInit = 'Email';
                  $activeModal.find('.gfLP_tabs li[data-tab="Email"]').addClass('active');
                  $activeModal.find('.gfLP_content[data-tab="Email"]').addClass('active');
                  _this.ajaxRequest('Email');
                } else if (valueInit.indexOf('tel:') >= 0) {
                  _tabInit = 'Phone';
                  $activeModal.find('.gfLP_tabs li[data-tab="Phone"]').addClass('active');
                  $activeModal.find('.gfLP_content[data-tab="Phone"]').addClass('active');
                  _this.ajaxRequest('Phone');
                } else if (valueInit.indexOf('#') >= 0 && valueInit.length > 1) {
                  _tabInit = 'Scroll To';
                  $activeModal.find('.gfLP_tabs li[data-tab="Scroll To"]').addClass('active');
                  $activeModal.find('.gfLP_content[data-tab="Scroll To"]').addClass('active');
                  _this.ajaxRequest('Scroll To');
                } else {
                  _tabInit = 'Pages';
                  $activeModal.find('.gfLP_tabs li[data-tab="Pages"]').addClass('active');
                  $activeModal.find('.gfLP_content[data-tab="Pages"]').addClass('active');
                  _this.ajaxRequest('Pages');
                }
              }
            }
            _this.applyEvents($activeModal);
          },
          onClose: function () {
            const url = $activeModal.find('#gfLP_link').val();

            $element.attr('value', url).val(url).trigger('input-change').trigger('value-change').trigger('link-change');
            $gfLeftSideBar
              .find('.linkTarget,#linkTarget,#url-target,#icon-target')
              .attr('value', $activeModal.find('#gfLP_target').attr('data-value'))
              .val($activeModal.find('#gfLP_target').attr('data-value'))
              .trigger('value-change')
              .trigger('input-change');

            $element.trigger('history-change');

            _this.settings.detectChange();
            $activeModal.remove();
            _countCheckActive = 0;
          },
          onCancel: function () {
            _this.settings.detectChange();
            $activeModal.remove();
            _countCheckActive = 0;
          },
          onSave: function () {
            const url = $activeModal.find('#gfLP_link').val();
            $element.attr('value', url).val(url).trigger('input-change').trigger('value-change').trigger('link-change');
            $gfLeftSideBar
              .find('.linkTarget,#linkTarget,#url-target,#icon-target')
              .attr('value', $activeModal.find('#gfLP_target').attr('data-value'))
              .val($activeModal.find('#gfLP_target').attr('data-value'))
              .trigger('value-change')
              .trigger('input-change');

            $element.trigger('history-change');

            _this.settings.detectChange();
            $activeModal.remove();
            _countCheckActive = 0;
          },
        });
        $activeModal.data('gfmodalnew').onShow();
      });

      $pickAction.off('click').on('click', function () {
        const $btnAction = jQuery(this);
        $dad.css({
          'z-index': '30',
        });
        _this.settings.onOpacity();

        const $popupElm = $gryffBody.find('.gf-popupAnchor');

        // INIT VALUE
        const linkTarget = $element.attr('value');
        let initValue = '';
        let initItem = '';
        if (linkTarget.indexOf('#show-') !== -1 && $popupElm.length > 0) {
          initValue = 'show';
          initItem = linkTarget.split('#show-')[1];
        }
        if (linkTarget.indexOf('#hide') !== -1 && $popupElm.length > 0) {
          initValue = 'hide';
        }

        let _template = '<div class="pickAction">';
        _template +=
          '<select class="pickActionType" value="' +
          initValue +
          '" default_value="' +
          initValue +
          '" data-value="show,hide" data-columns="Show Popup,Hide Popup" style="display: none;" data-disable="true"></select>';

        _template += '<div class="pickActionList">';
        if ($popupElm.length > 0) {
          _template += '<div class="gfSGSubTitle">List Popup</div>';
          _template += '<div class="gfSGclear"></div>';
          _template += '<div class="pickActionItems">';
          for (let i = 0; i < $popupElm.length; i++) {
            const $pop = jQuery($popupElm[i]);
            _template +=
              '<div class="pickActionItemPopup" data-value="m-' +
              $pop.attr('data-id') +
              '">' +
              $pop.find('span').text() +
              '</div>';
          }
          _template += '</div>';
        }
        _template += '</div>';

        _template +=
          '<div class="pickActionItemNone">*You do not have any popups yet. Please go back and create a popup to use this feature.</div>';
        _template += '<div class="pickActionItemHide">*Will work with popup windows that contain this button</div>';
        _template += '</div>';

        const $popup = jQuery(_template);

        $dad.after($popup);

        // Show/hide desc no popup init
        if ($popupElm.length == 0) {
          $popup.find('.pickActionItemNone').show();
        } else {
          $popup.find('.pickActionItemNone').hide();
        }

        // Show/hide desc hide popup init
        if ($popupElm.length > 0 && initValue == 'hide') {
          $popup.find('.pickActionItemHide').show();
        } else {
          $popup.find('.pickActionItemHide').hide();
        }

        // Show/hide popup init
        if ($popupElm.length > 0 && initValue == 'show') {
          $popup.find('.pickActionList').show();
        } else {
          $popup.find('.pickActionList').hide();
        }

        // Show active item init
        $popup.find('.pickActionItemPopup[data-value="' + initItem + '"]').addClass('active');

        $popup.find('.pickActionType').gfSegment({
          title: 'Action',
          onSelected: function (value) {
            // Show/hide popup
            if ($popupElm.length > 0 && value == 'show') {
              $popup.find('.pickActionList').show();
            } else {
              $popup.find('.pickActionList').hide();
            }

            if ($popupElm.length > 0 && value == 'hide') {
              $popup.find('.pickActionItemHide').show();
              const link = '#hide';
              $element.attr('value', link).trigger('value-change').trigger('input-change').trigger('history-change');

              // Remove all active class in packActionItemPopup
              $popup.find('.pickActionItemPopup').removeClass('active');
            } else {
              $popup.find('.pickActionItemHide').hide();
            }

            // Show/hide desc no popup
            if ($popupElm.length == 0) {
              $popup.find('.pickActionItemNone').show();
            } else {
              $popup.find('.pickActionItemNone').hide();
            }
          },
        });

        let top = $btnAction.offset().top;
        if (top + $popup.height() + 80 > $(window).height()) {
          top = top + $popup.height() + 50;
          const srcollTop = top - $(window).height();
          top = $btnAction.offset().top - (srcollTop + 80);
        } else if (top < 0) {
          top = 60;
        } else {
          top = top - 70;
        }
        $popup.css({
          top: top,
        });

        // background phủ iframe
        $gfLeftSideBar.data('gfleftsidebar').onBackgroundIframe('backgroundPickerAction');
        setTimeout(function () {
          $gryffBody
            .find('.backgroundPickerAction')
            .off('mousedown.removeBackground')
            .on('mousedown.removeBackground', function () {
              $popup.remove();
              _this.settings.offOpacity();

              $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('backgroundPickerAction');
              $dad.css({
                'z-index': 200,
              });
            });
        }, 0);

        $gfLeftSideBar
          .find('.gfSGBackground')
          .off('mousedown.picker')
          .on('mousedown.picker', function (e) {
            const $that = $(this);
            const $column = $that.parent('.columns-advanced');
            if (e.which != '3' && $column.length == 0) {
              const $target = jQuery(e.target);
              if ($target.closest('.pickAction').length == 0) {
                $popup.remove();
                _this.settings.offOpacity();
                $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('backgroundPickerAction');
                $dad.css({
                  'z-index': 200,
                });
              }
            }
          });

        // EVENT
        $popup.find('.pickActionItemPopup').click(function (e) {
          const $this = jQuery(this);
          if ($this.hasClass('active')) {
            $element.attr('value', '#').trigger('value-change').trigger('input-change').trigger('history-change');

            $this.removeClass('active');
          } else {
            const id = $this.attr('data-value');
            const link = '#show-' + id;
            $element.attr('value', link).trigger('value-change').trigger('input-change').trigger('history-change');

            $popup.find('.pickActionItemPopup').removeClass('active');
            $this.addClass('active');
          }
        });
      });

      $element.on('require-hide', function () {
        $pickLink.hide();
        $pickAction.hide();
      });
      $element.on('require-show', function () {
        $pickLink.show();
        $pickAction.show();
      });
    };

    this.applyEvents = function ($activeModal) {
      // Focus input link
      setTimeout(function () {
        $activeModal.find('.gfLP_header-left input').focus();
      }, 200);

      // Target
      $activeModal.find('.gfLP_header-right span').on('click', function () {
        const $that = $(this);
        if (!$that.hasClass('show')) {
          $activeModal.find('.gfLP_header-right ul').show();
          $that.addClass('show');
          $activeModal.on('click', function (e) {
            if (
              $(e.target).closest('.gfLP_header-right ul').length <= 0 &&
              $(e.target).closest('.gfLP_header-right span').length <= 0
            ) {
              $that.removeClass('show');
              $activeModal.find('.gfLP_header-right ul').hide();
            }
          });
          $activeModal
            .find('.gfLP_header-right ul li')
            .off('click')
            .on('click', function () {
              const value = $(this).attr('data-value');
              const text = $(this).text();
              _dataTarget = value;
              $activeModal.find('.gfLP_header-right span').attr('data-value', value).text(text);
              $that.removeClass('show');
              $activeModal.find('.gfLP_header-right ul').hide();
            });
        } else {
          $that.removeClass('show');
          $activeModal.find('.gfLP_header-right ul').hide();
        }
      });

      // clear link
      $activeModal
        .find('.gfLP_header-left .gfLP_icon_clear_body')
        .off('click')
        .on('click', function () {
          $activeModal.find('.gfLP_content li.active').removeClass('active');
          _this.changeLink('');
        });

      // Change Tabs
      const $tabs = $activeModal.find('.gfLP_tabs');
      $tabs.find('li').on('click', function () {
        const $that = $(this);
        if (!$that.hasClass('active')) {
          $tabs.find('li').removeClass('active');
          $that.addClass('active');

          // on loading seleect tab;
          $activeModal.data('gfmodalnew').onLoading();

          const dataTab = $that.attr('data-tab');
          _this.ajaxRequest(dataTab);
          $activeModal.find('.gfLP_content').removeClass('active');
          $activeModal.find('.gfLP_content[data-tab="' + dataTab + '"]').addClass('active');

          // hide search
          if (dataTab == 'Email' || dataTab == 'Phone') {
            $activeModal.find('.gfLP_search-link').hide();
          } else {
            $activeModal.find('.gfLP_search-link').show();
            //refresh
            _this.onSearch();
          }
        }
      });

      const $emailList = $activeModal.find('.email-list');
      $emailList.find('input,textarea').on('keyup paste', function () {
        const email = $emailList.find('input[name="email"]').val();
        const subject = $emailList.find('input[name="subject"]').val();
        const message = $emailList.find('textarea[name="message"]').val();
        if (HELPER.isEmail(email)) {
          $activeModal.find('.gfLP_content li.active').removeClass('active');
          let link = '';
          if (email !== '') {
            link += 'mailto:' + email.trim();
            if (subject !== '' && message !== '') {
              link += '?subject=' + subject + '&body=' + message;
            } else if (subject != '') {
              link += '?subject=' + subject;
            } else if (message != '') {
              link += '?body=' + message;
            }
          }

          _this.changeLink(link);
        }
      });

      const $phoneList = $activeModal.find('.phone-list');
      $phoneList.find('input,textarea').on('keyup paste', function () {
        const phone = $phoneList.find('input[name="phone"]').val();
        $activeModal.find('.gfLP_content li.active').removeClass('active');
        const link = 'tel:' + phone.trim();
        _this.changeLink(link);
      });

      $activeModal
        .find('.gfLP_search-link input')
        .off('keyup paste')
        .on('keyup paste', function () {
          _this.onSearch();
        });
    };

    this.activeElementInit = function ($page) {
      if ($page.find('li a[href="' + $element.val() + '"]').length > 0) {
        _countCheckActive++;
        $($page.find('ul')).prepend(
          $(
            $page
              .find('li a[href="' + $element.val() + '"]')
              .parents('li')
              .addClass('active'),
          ),
        );
      } else {
        if (_countCheckActive == 0 && $element.val().trim() !== '') {
          _countCheckActive++;
          let url;
          const s = $element.val();
          switch (_tabInit) {
            case 'Pages':
              url = '/api/page/searchPageByHandle.html';
              break;
            case 'Products':
              url = '/api/product/searchProductByHandle.html';
              break;
            /* case 'Collections':
                            url = '/api/collection/searchCollectionByHandle.html';
                            break;
                        case 'Articles':
                            url = '/api/active/searchArticleByHandle.html';
                            break; */
          }
          const shop = $gfFrame.data('gfframe').getShopDomain();
          if (url) {
            const data = {
              shop: shop,
              s: s.split('/').pop(),
              limit: 1,
            };
            GET(url, data)
              .then((res) => {
                const data = res.data;
                if (data && data.pages && data.pages.length > 0) {
                  _dataPages.push(data.pages[0]);
                  $($page.find('ul')).prepend(
                    '<li class="active"><span class="gfLP_icon_pages"></span><a href="' +
                      data.pages[0].handle +
                      '">' +
                      data.pages[0].title +
                      '</a></li>',
                  );
                } else if (data && data.products && data.products.length > 0) {
                  _dataProducts.push(data.products[0]);
                  $($page.find('ul')).prepend(
                    '<li class="active"><span class="gfLP_icon_products"></span><a href="' +
                      data.products[0].handle +
                      '">' +
                      data.products[0].title +
                      '</a></li>',
                  );
                } else if (data && data.collections && data.collections.length > 0) {
                  _dataCollections.push(data.collections[0]);
                  $($page.find('ul')).prepend(
                    '<li class="active"><span class="gfLP_icon_collections"></span><a href="' +
                      data.collections[0].handle +
                      '">' +
                      data.collections[0].title +
                      '</a></li>',
                  );
                } else if (data && data.article && data.article.length > 0) {
                  _dataArticles.push(data.article[0]);
                  $($page.find('ul')).prepend(
                    '<li class="active"><span class="gfLP_icon_article"></span><a href="' +
                      data.article[0].handle +
                      '">' +
                      data.article[0].title +
                      '</a></li>',
                  );
                }

                $page
                  .find('li')
                  .off('click')
                  .on('click', function () {
                    const link = $(this).find('a').attr('href');

                    _this.changeLink(link);

                    $activeModal.find('.gfLP_content li.active').removeClass('active');
                    $(this).addClass('active');

                    return false;
                  });
              })
              .catch((err) => {});
          }
        }
      }
    };

    this.ajaxRequest = function (type) {
      if (type == 'Pages') {
        // Get Pages
        const $pageList = $activeModal.find('.page-list');
        if (_dataPages.length > 0) {
          const _pages = _dataPages;
          var num = _pages.length,
            html = '';
          for (var i = 0; i < num; i++) {
            html +=
              '<li><span class="gfLP_icon_pages"></span><a href="/pages/' +
              _pages[i].handle +
              '">' +
              _pages[i].title +
              '</a></li>';
          }
          html = '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';

          // optis scroll
          $pageList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();

          // Off loading;
          setTimeout(function () {
            $activeModal.data('gfmodalnew').offLoading();
          }, 0);

          _this.activeElementInit($pageList);
          $pageList
            .find('li')
            .off('click')
            .on('click', function () {
              const link = $(this).find('a').attr('href');

              _this.changeLink(link);

              $activeModal.find('.gfLP_content li.active').removeClass('active');
              $(this).addClass('active');

              return false;
            });
        } else {
          var req = api.getPages();
          GET(api.getPages().url)
            .then((res) => {
              const data = res.data;
              let _pages = [];

              if (data.pages.length) {
                _pages = data.pages;
                _dataPages = data.pages;
              }
              let num = _pages.length,
                html = '';
              for (let i = 0; i < num; i++) {
                html +=
                  '<li><span class="gfLP_icon_pages"></span><a href="/pages/' +
                  _pages[i].handle +
                  '">' +
                  _pages[i].title +
                  '</a></li>';
              }
              html = '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';

              // optis scroll
              $pageList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();
              // Off loading;
              setTimeout(function () {
                $activeModal.data('gfmodalnew').offLoading();
              }, 0);

              _this.activeElementInit($pageList);
              $pageList
                .find('li')
                .off('click')
                .on('click', function () {
                  const link = $(this).find('a').attr('href');

                  _this.changeLink(link);

                  $activeModal.find('.gfLP_content li.active').removeClass('active');
                  $(this).addClass('active');

                  return false;
                });
            })
            .catch((err) => {
              $pageList.html('No page found');
            });
        }
      } else if (type == 'Products') {
        // Get Products
        const $productList = $activeModal.find('.product-list');
        if (_dataProducts.length > 0) {
          const _products = _dataProducts;
          var num = _products.length,
            html = '';
          for (var i = 0; i < num; i++) {
            html +=
              '<li><span class="gfLP_icon_products"></span><a href="/products/' +
              _products[i].handle +
              '">' +
              _products[i].title +
              '</a></li>';
          }
          html = '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';

          $productList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();
          // Off loading;
          setTimeout(function () {
            $activeModal.data('gfmodalnew').offLoading();
          }, 0);

          _this.activeElementInit($productList);
          $productList
            .find('li')
            .off()
            .on('click', function () {
              const link = $(this).find('a').attr('href');

              _this.changeLink(link);

              $activeModal.find('.gfLP_content li.active').removeClass('active');
              $(this).addClass('active');
              return false;
            });
        } else {
          HELPER.getNewestProducts(function (jsonData) {
            let _products = [];
            if (jsonData.products.length) {
              _products = jsonData.products;
              _dataProducts = jsonData.products;
            }
            let num = _products.length,
              html = '';
            for (let i = 0; i < num; i++) {
              html +=
                '<li><span class="gfLP_icon_products"></span><a href="/products/' +
                _products[i].handle +
                '">' +
                _products[i].title +
                '</a></li>';
            }
            html = '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';

            $productList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();
            // Off loading;
            setTimeout(function () {
              $activeModal.data('gfmodalnew').offLoading();
            }, 0);

            _this.activeElementInit($productList);
            $productList
              .find('li')
              .off()
              .on('click', function () {
                const link = $(this).find('a').attr('href');

                _this.changeLink(link);

                $activeModal.find('.gfLP_content li.active').removeClass('active');
                $(this).addClass('active');
                return false;
              });
          }, 249);
        }
      } else if (type == 'Collections') {
        //Get collections
        const $collectionsList = $activeModal.find('.collection-list');
        if (_dataCollections.length > 0) {
          const _collections = _dataCollections;
          var num = _collections.length,
            html = '';
          if (num > 0) {
            for (var i = 0; i < num; i++) {
              html +=
                '<li><span class="gfLP_icon_collections"></span><a href="/collections/' +
                _collections[i].handle +
                '">' +
                _collections[i].title +
                '</a></li>';
            }

            html = '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';
          } else {
            html +=
              '<ul><li class="gfLP_collection_notfound"><div class="gfLP_collection_notfound_body"><div class="gfLP_icon_collection_notfound"></div><p>No Collections</p></div></li></ul>';
          }

          $collectionsList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();

          // Off loading;
          setTimeout(function () {
            $activeModal.data('gfmodalnew').offLoading();
          }, 0);

          _this.activeElementInit($collectionsList);
          $collectionsList
            .find('li')
            .off('click')
            .on('click', function () {
              const link = $(this).find('a').attr('href');

              _this.changeLink(link);

              $activeModal.find('.gfLP_content li.active').removeClass('active');
              $(this).addClass('active');
              return false;
            });
        } else {
          GET(api.getCollections().url)
            .then((res) => {
              const jsonData = res.data;
              if (!jQuery.isEmptyObject(jsonData)) {
                let _collections = [];
                if (jsonData.collections.length) {
                  _collections = jsonData.collections;
                  _dataCollections = jsonData.collections;

                  // COLLECTION 2019
                  for (var i = 0; i < _collections.length; i++) {
                    HELPER.updateCollectionInList(_collections[i]);
                  }
                }
                let num = _collections.length,
                  html = '';
                if (num > 0) {
                  for (var i = 0; i < num; i++) {
                    html +=
                      '<li><span class="gfLP_icon_collections"></span><a href="/collections/' +
                      _collections[i].handle +
                      '">' +
                      _collections[i].title +
                      '</a></li>';
                  }

                  html =
                    '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';
                } else {
                  html +=
                    '<ul><li class="gfLP_collection_notfound"><div class="gfLP_collection_notfound_body"><div class="gfLP_icon_collection_notfound"></div><p>No Collections</p></div></li></ul>';
                }
                $collectionsList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();

                // Off loading;
                setTimeout(function () {
                  $activeModal.data('gfmodalnew').offLoading();
                }, 0);

                _this.activeElementInit($collectionsList);
              }
              $collectionsList
                .find('li')
                .off('click')
                .on('click', function () {
                  const link = $(this).find('a').attr('href');

                  _this.changeLink(link);

                  $activeModal.find('.gfLP_content li.active').removeClass('active');
                  $(this).addClass('active');
                  return false;
                });
            })
            .catch((err) => {
              $collectionsList.html('No collection found');
            });
        }
      } else if (type == 'Articles') {
        //Get collections
        const $articleList = $activeModal.find('.articles-list');
        if (_dataArticles.length > 0) {
          const _articles = _dataArticles;
          var num = _articles.length,
            html = '';

          for (var i = 0; i < num; i++) {
            let blog = 'news';
            if (_articles[i].blog != undefined && _articles[i].blog != '') {
              blog = _articles[i].blog;
            }

            html +=
              '<li><span class="gfLP_icon_article"></span><a href="/blogs/' +
              blog +
              '/' +
              _articles[i].handle +
              '">' +
              _articles[i].title +
              '</a></li>';
          }

          html = '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';

          $articleList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();

          // Off loading;
          setTimeout(function () {
            $activeModal.data('gfmodalnew').offLoading();
          }, 0);

          _this.activeElementInit($articleList);
          $articleList
            .find('li')
            .off('click')
            .on('click', function () {
              const link = $(this).find('a').attr('href');

              _this.changeLink(link);

              $activeModal.find('.gfLP_content li.active').removeClass('active');
              $(this).addClass('active');
              return false;
            });
        } else {
          const shop = $gfFrame.data('gfframe').getShopDomain();
          var req = api.getArticles();
          const data = {
            shop: shop,
            limit: 249,
            fields: 'id,title,handle,updated_at,created_at',
          };
          GET(api.getArticles().url, data)
            .then((res) => {
              const jsonData = res.data;
              if (!jQuery.isEmptyObject(jsonData)) {
                let _articles = [];
                if (jsonData.articles.length) {
                  _articles = jsonData.articles;
                  _dataArticles = jsonData.articles;
                }
                let num = _articles.length,
                  html = '';

                for (let i = 0; i < num; i++) {
                  let blog = 'news';
                  if (_articles[i].blog != undefined && _articles[i].blog != '') {
                    blog = _articles[i].blog;
                  }
                  html +=
                    '<li><span class="gfLP_icon_article"></span><a href="/blogs/' +
                    blog +
                    '/' +
                    _articles[i].handle +
                    '">' +
                    _articles[i].title +
                    '</a></li>';
                }

                html =
                  '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';

                $articleList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();
                // Off loading;
                setTimeout(function () {
                  $activeModal.data('gfmodalnew').offLoading();
                }, 0);

                _this.activeElementInit($articleList);
              }
              $articleList
                .find('li')
                .off('click')
                .on('click', function () {
                  const link = $(this).find('a').attr('href');

                  _this.changeLink(link);

                  $activeModal.find('.gfLP_content li.active').removeClass('active');
                  $(this).addClass('active');
                  return false;
                });
            })
            .catch((err) => {
              $articleList.html('No collection found');
            });
        }
      } else if (type == 'Scroll To') {
        //Get Sections
        const $sectionList = $activeModal.find('.section-list');

        var html =
          '<div class="gfLP_views_tutorial_scrollto"><span class="gfLP_icon_info"></span><span>You can use a link to scroll to any section on current page. <a href="https://help.gempages.net/articles/create-an-anchor-link-scrolling-down-to-a-specific-spot" target="_blank">Watch Tutorial</a></span></div>';
        const $childs = $gryffEditor.children('.gf_row, .element-wrap, .module-wrap').each(function () {
          const thisID = jQuery(this).attr('id');
          const label = jQuery(this).attr('data-label');
          const text = jQuery(this).text().trim().slice(0, 80);
          const txt = label;

          html += '<li data-sections="true">';
          html += '<span class="gfLP_icon_sections"></span>';
          html += '<div class="gfLP_sections_meta">';
          html += '<a href="#' + thisID + '">' + txt + '</a>';
          html += '<div class="gfLP_content_sectionID">- id:' + thisID.replace(/\D/g, '') + '</div>';
          if (text.length > 0) {
            html += '<div class="gfLP_sections_desc">' + text + '</div>';
          } else {
            html += '<div class="gfLP_sections_desc">No content</div>';
          }
          html += '</div>';
          html += '</li>';
        });
        html = '<div class="optiscroll-content" style="right: -17px; bottom: -17px;"><ul>' + html + '</ul></div>';
        $sectionList.html(html).addClass('optiscroll').addClass('has-vtrack').optiscroll();

        // Off loading;
        setTimeout(function () {
          $activeModal.data('gfmodalnew').offLoading();
        }, 0);

        _this.activeElementInit($sectionList);
        $sectionList
          .find('li')
          .off('click')
          .on('click', function () {
            const link = $(this).find('a').attr('href');

            _this.changeLink(link);

            $activeModal.find('.gfLP_content li.active').removeClass('active');
            $(this).addClass('active');
            return false;
          });
      } else if (type == 'Email') {
        var link = $activeModal.find('#gfLP_link').val();
        if (link != '' && link.indexOf('mailto:') != -1) {
          var $emailList = $activeModal.find('.email-list');
          let email = link.match(/mailto:([^\?]*)/);
          email = email[1] ? email[1] : '';
          $emailList.find('input[name="email"]').val(email);

          let subject = link.match(/subject=([^&]+)/);
          subject = subject ? subject[1].replace(/\+/g, ' ') : '';
          $emailList.find('input[name="subject"]').val(subject);

          let body = link.match(/body=([^&]+)/);
          body = body ? body[1].replace(/\+/g, ' ') : '';
          $emailList.find('textarea[name="message"]').val(body);

          var link = '';
          if (email !== '') {
            link += 'mailto:' + email.trim();
            if (subject !== '' && body !== '') {
              link += '?subject=' + subject + '&body=' + body;
            } else if (subject != '') {
              link += '?subject=' + subject;
            } else if (body != '') {
              link += '?body=' + body;
            }
          }

          _this.changeLink(link);
        }

        setTimeout(function () {
          $activeModal.data('gfmodalnew').offLoading();
        }, 0);
      } else if (type == 'Phone') {
        var link = $activeModal.find('#gfLP_link').val();
        if (link != '' && link.indexOf('tel:') != -1) {
          var $emailList = $activeModal.find('.phone-list');
          let phone = link.match(/tel:([^\?]*)/);
          phone = phone[1] ? phone[1] : '';
          $emailList.find('input[name="phone"]').val(phone);
          _this.changeLink('tel:' + phone.trim());
        }

        setTimeout(function () {
          $activeModal.data('gfmodalnew').offLoading();
        }, 0);
      } else {
        // Off loading;
        setTimeout(function () {
          $activeModal.data('gfmodalnew').offLoading();
        }, 0);
      }
    };

    this.onSearch = function () {
      const $crTab = $activeModal.find('.gfLP_content.active');
      $crTab.find('ul .gfLP_notFound').remove();
      const $lis = $crTab.find('li').not('.gfLP_notFound').hide();
      const s = $activeModal.find('.gfLP_search-link input').val().trim().replace(/\s+/g, ' ').toLowerCase();
      if (s !== '') {
        const lengthList = $lis.length;
        let count = 0;
        for (let i = 0; i < lengthList; i++) {
          const txt = $($lis[i]).find('a').text().trim().replace(/\s+/g, ' ').toLowerCase();
          if (txt.indexOf(s) >= 0) {
            $($lis[i]).show();
            count++;
          }
        }
        clearTimeout(delaySearch);
        const tab = $activeModal.find('.gfLP_content.active').attr('data-tab');
        if (tab == 'Pages' || tab == 'Products' || tab == 'Collections' || tab == 'Articles') {
          delaySearch = setTimeout(function () {
            _this.searchAjax(tab, count, s);
          }, 500);
        } else {
          if (count == 0) {
            let _notfound =
              '<li class="gfLP_notFound"><p>Your search &ldquo;' + s + '&rdquo; did not match any records.<p>';
            _notfound += '<p>Suggestions:</p>';
            _notfound += '<p>&#8226;  Try different keywords.</p>';
            _notfound += '<p>&#8226;  Try more general keywords.</p>';
            _notfound += '<p>&#8226;  Try fewer keywords.</p></li>';
            $crTab.find('ul').append(_notfound);
          }
        }
        return false;
      } else {
        $crTab.find('li').show();
      }
    };

    this.searchAjax = function (tab, count, s) {
      const $crTab = $activeModal.find('.gfLP_content.active');
      const shop = $gfFrame.data('gfframe').getShopDomain();
      switch (tab) {
        case 'Pages': {
          const data = {
            shop: shop,
            s: s,
            limit: 249,
          };
          GET('/api/page/searchPages.html', data)
            .then((res) => {
              const data = res.data;
              let _pages = [];
              if (data.pages.length) {
                _pages = data.pages;
              }
              // Check search !== search off
              _pages = _pages.filter((page, index, self) => index === self.findIndex((t) => t.id === page.id));
              _pages = _pages.filter((page) => !_dataPages.some((p) => p.id === page.id));
              // push store data
              for (var i = 0; i < _pages.length; i++) {
                _dataPages.push(_pages[i]);
              }
              if (_pages.length > 0) {
                let num = _pages.length,
                  html = '';
                for (var i = 0; i < num; i++) {
                  html +=
                    '<li><span class="gfLP_icon_pages"></span><a href="/pages/' +
                    _pages[i].handle +
                    '">' +
                    _pages[i].title +
                    '</a></li>';
                }

                const $pageList = $activeModal.find('.page-list');
                $pageList.find('ul').append(html);
                $pageList
                  .find('li')
                  .off('click')
                  .on('click', function () {
                    const link = $(this).find('a').attr('href');

                    _this.changeLink(link);

                    $activeModal.find('.gfLP_content li.active').removeClass('active');
                    $(this).addClass('active');

                    return false;
                  });
              } else {
                if (count == 0) {
                  let _notfound =
                    '<li class="gfLP_notFound"><p>Your search &ldquo;' + s + '&rdquo; did not match any records.<p>';
                  _notfound += '<p>Suggestions:</p>';
                  _notfound += '<p>&#8226;  Try different keywords.</p>';
                  _notfound += '<p>&#8226;  Try more general keywords.</p>';
                  _notfound += '<p>&#8226;  Try fewer keywords.</p></li>';
                  $crTab.find('ul').append(_notfound);
                }
              }
              return false;
            })
            .catch((err) => {
              $pageList.html('No page found');
            });
          break;
        }
        case 'Products': {
          const data = {
            shop: shop,
            s: s,
            limit: 249,
          };
          GET('/api/product/searchProducts.html', data)
            .then((res) => {
              const data = res.data;
              let _products = [];
              if (data.products.length) {
                _products = data.products;
              }
              // Check search !== search off
              _products = _products.filter((product, index, self) => index === self.findIndex((t) => t.id === product.id));
              _products = _products.filter((product) => !_dataProducts.some((p) => p.id === product.id));
              // push store data
              for (var i = 0; i < _products.length; i++) {
                _dataProducts.push(_products[i]);
              }
              if (_products.length > 0) {
                let num = _products.length,
                  html = '';
                for (var i = 0; i < num; i++) {
                  html +=
                    '<li><span class="gfLP_icon_products"></span><a href="/products/' +
                    _products[i].handle +
                    '">' +
                    _products[i].title +
                    '</a></li>';
                }

                const $productList = $activeModal.find('.product-list');

                $productList.find('ul').append(html);

                $productList
                  .find('li')
                  .off('click')
                  .on('click', function () {
                    const link = $(this).find('a').attr('href');

                    _this.changeLink(link);

                    $activeModal.find('.gfLP_content li.active').removeClass('active');
                    $(this).addClass('active');

                    return false;
                  });
              } else {
                if (count == 0) {
                  let _notfound =
                    '<li class="gfLP_notFound"><p>Your search &ldquo;' + s + '&rdquo; did not match any records.<p>';
                  _notfound += '<p>Suggestions:</p>';
                  _notfound += '<p>&#8226;  Try different keywords.</p>';
                  _notfound += '<p>&#8226;  Try more general keywords.</p>';
                  _notfound += '<p>&#8226;  Try fewer keywords.</p></li>';
                  $crTab.find('ul').append(_notfound);
                }
              }
              return false;
            })
            .catch((err) => {
              $pageList.html('No page found');
            });
          break;
        }
        case 'Collections': {
          const data = {
            shop: shop,
            s: s,
            limit: 249,
          };
          GET('/api/collection/searchCollections.html', data)
            .then((res) => {
              const data = res.data;
              let _collections = [];
              if (data.collections.length) {
                _collections = data.collections;
              }
              // Check search !== search off
              _collections = _collections.filter((collection, index, self) => index === self.findIndex((t) => t.id === collection.id));
              _collections = _collections.filter((collection) => !_dataCollections.some((c) => c.id === collection.id));
              // push store data
              for (var i = 0; i < _collections.length; i++) {
                _dataCollections.push(_collections[i]);
              }
              if (_collections.length > 0) {
                let num = _collections.length,
                  html = '';
                for (var i = 0; i < num; i++) {
                  html +=
                    '<li><span class="gfLP_icon_collections"></span><a href="/collections/' +
                    _collections[i].handle +
                    '">' +
                    _collections[i].title +
                    '</a></li>';
                }

                const $collectionsList = $activeModal.find('.collection-list');

                $collectionsList.find('ul').append(html);

                $collectionsList
                  .find('li')
                  .off('click')
                  .on('click', function () {
                    const link = $(this).find('a').attr('href');

                    _this.changeLink(link);

                    $activeModal.find('.gfLP_content li.active').removeClass('active');
                    $(this).addClass('active');

                    return false;
                  });
              } else {
                if (count == 0) {
                  let _notfound =
                    '<li class="gfLP_notFound"><p>Your search &ldquo;' + s + '&rdquo; did not match any records.<p>';
                  _notfound += '<p>Suggestions:</p>';
                  _notfound += '<p>&#8226;  Try different keywords.</p>';
                  _notfound += '<p>&#8226;  Try more general keywords.</p>';
                  _notfound += '<p>&#8226;  Try fewer keywords.</p></li>';
                  $crTab.find('ul').append(_notfound);
                }
              }
              return false;
            })
            .catch((err) => {
              $pageList.html('No page found');
            });
          break;
        }
        case 'Articles': {
          const data = {
            shop: shop,
            s: s,
            limit: 249,
          };
          GET('/api/article/searchArticles.html', data)
            .then((res) => {
              const data = res.data;
              let _articles = [];
              if (data.articles.length) {
                _articles = data.articles;
              }
              // Check search !== search off
              _articles = _articles.filter((article, index, self) => index === self.findIndex((t) => t.id === article.id));
              _articles = _articles.filter((article) => !_dataArticles.some((a) => a.id === article.id));
              // push store data
              for (var i = 0; i < _articles.length; i++) {
                _dataArticles.push(_articles[i]);
              }
              if (_articles.length > 0) {
                let num = _articles.length,
                  html = '';
                for (var i = 0; i < num; i++) {
                  let blog = 'news';
                  if (_articles[i].blog != undefined && _articles[i].blog != '') {
                    blog = _articles[i].blog;
                  }
                  html +=
                    '<li><span class="gfLP_icon_article"></span><a href="/blogs/' +
                      blog +
                    '/' +
                      _articles[i].handle +
                    '">' +
                    _articles[i].title +
                    '</a></li>';
                }

                const $articleList = $activeModal.find('.articles-list');

                $articleList.find('ul').append(html);

                $articleList
                  .find('li')
                  .off('click')
                  .on('click', function () {
                    const link = $(this).find('a').attr('href');

                    _this.changeLink(link);

                    $activeModal.find('.gfLP_content li.active').removeClass('active');
                    $(this).addClass('active');

                    return false;
                  });
              } else {
                if (count == 0) {
                  let _notfound =
                    '<li class="gfLP_notFound"><p>Your search &ldquo;' + s + '&rdquo; did not match any records.<p>';
                  _notfound += '<p>Suggestions:</p>';
                  _notfound += '<p>&#8226;  Try different keywords.</p>';
                  _notfound += '<p>&#8226;  Try more general keywords.</p>';
                  _notfound += '<p>&#8226;  Try fewer keywords.</p></li>';
                  $crTab.find('ul').append(_notfound);
                }
              }
              return false;
            })
            .catch((err) => {
              $pageList.html('No page found');
            });
          break;
        }
      }
    };

    this.changeLink = function (value) {
      $activeModal.find('.gfLP_header-left input').val(value);
    };

    this.getTarget = function () {
      return _dataTarget;
    };

    this.setTarget = function (value) {
      _dataTarget = value;
      let text = 'Current Tab';
      if (value == '_blank') {
        text = 'New Tab';
      }
      $activeModal.find('.gfLP_header-right span').attr('data-value', value).text(text);
    };

    this.init();
  };

  jQuery.fn.gfLinkPicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gflinkpicker')) {
        const plugin = new jQuery.gfLinkPicker(this, options);
        jQuery(this).data('gflinkpicker', plugin);
      }
    });
  };
})(jQuery);
